(() => {
  const cfg = window.MiraPWA || {};
  const DISMISS_KEY = 'mira_pwa_install_dismissed_until';
  const DISMISS_DAYS = 7;
  const SHOW_DELAY = 3500;

  const isStandalone = () =>
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  const isIOS = () =>
    /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const isMobileOrTablet = () =>
    window.matchMedia('(max-width: 1100px)').matches ||
    window.matchMedia('(pointer: coarse)').matches;

  const dismissedRecently = () => {
    const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return Date.now() < until;
  };

  const dismissForAWeek = () => {
    localStorage.setItem(
      DISMISS_KEY,
      String(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000)
    );
  };

  if (isStandalone() || !isMobileOrTablet() || dismissedRecently()) return;

  let deferredPrompt = null;
  let promptEl = null;

  function buildPrompt(mode) {
    if (promptEl) return promptEl;

    const wrapper = document.createElement('div');
    wrapper.id = 'mira-pwa-install';
    wrapper.innerHTML = `
      <div class="mira-pwa-card" role="dialog" aria-modal="false" aria-label="Install Mira Dreadlocks app">
        <img class="mira-pwa-icon" src="${cfg.icon || ''}" alt="Mira Dreadlocks">
        <div>
          <h2 class="mira-pwa-title">Mira Dreadlocks on your device 🖤</h2>
          <p class="mira-pwa-text">
            Install our app for faster access to dreadlocks, accessories and your favorite styles.
          </p>
        </div>
        <button class="mira-pwa-close" type="button" aria-label="Close">×</button>
        <div class="mira-pwa-actions">
          <button class="mira-pwa-btn mira-pwa-btn--install" type="button">
            ${mode === 'ios' ? 'How to install' : 'Install App'}
          </button>
          <button class="mira-pwa-btn mira-pwa-btn--later" type="button">Not now</button>
        </div>
        <div class="mira-pwa-ios-help">
          On iPhone/iPad: tap <strong>Share</strong> in your browser, then choose
          <strong>Add to Home Screen</strong> → <strong>Add</strong>.
        </div>
      </div>
    `;

    document.body.appendChild(wrapper);
    promptEl = wrapper;

    const closeBtn = wrapper.querySelector('.mira-pwa-close');
    const laterBtn = wrapper.querySelector('.mira-pwa-btn--later');
    const installBtn = wrapper.querySelector('.mira-pwa-btn--install');
    const iosHelp = wrapper.querySelector('.mira-pwa-ios-help');

    const close = () => {
      dismissForAWeek();
      wrapper.classList.remove('is-visible');
    };

    closeBtn.addEventListener('click', close);
    laterBtn.addEventListener('click', close);

    installBtn.addEventListener('click', async () => {
      if (mode === 'ios') {
        iosHelp.classList.add('is-visible');
        return;
      }

      if (!deferredPrompt) return;

      deferredPrompt.prompt();
      try {
        await deferredPrompt.userChoice;
      } catch (e) {}
      deferredPrompt = null;
      wrapper.classList.remove('is-visible');
    });

    return wrapper;
  }

  function show(mode) {
    const el = buildPrompt(mode);
    setTimeout(() => {
      if (!isStandalone() && !dismissedRecently()) {
        el.classList.add('is-visible');
      }
    }, SHOW_DELAY);
  }

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    show('android');
  });

  window.addEventListener('appinstalled', () => {
    if (promptEl) promptEl.classList.remove('is-visible');
    localStorage.removeItem(DISMISS_KEY);
  });

  if (isIOS()) {
    show('ios');
  }
})();